import gql from 'graphql-tag';

// Hooks
import { useQuery } from '@apollo/react-hooks';
import { useMemo } from 'react';

// Types
import {
  GetGateGeometryQuery,
  GetGateGeometryQueryVariables,
} from 'src/app/gql/__generated__/hooks';

export const GET_GATE_GEOMETRIES = gql(`
  query getGateGeometry($gateIds: [Int!]!) {
      gatesByIds(ids: $gateIds) {
          id
          name
          geometry {
              ceilingAltitude
              floorAltitude
              rightPosition {
                  altitude
                  latitude
                  longitude
              }
              leftPosition {
                  altitude
                  latitude
                  longitude
              }
              anchorPosition {
                  altitude
                  latitude
                  longitude
              }
          }
      }
  }
`);

export const useGetGateGeometries = (gateIds: number[] | null) => {
  const { data, loading, error } = useQuery<GetGateGeometryQuery, GetGateGeometryQueryVariables>(
    GET_GATE_GEOMETRIES,
    {
      variables: { gateIds: gateIds || [] },
      skip: !gateIds || gateIds.length === 0,
      fetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      onError: error => {
        console.error('Error fetching gate geometries:', error);
      },
    }
  );

  const gates = useMemo(() => data?.gatesByIds || [], [data]);

  return {
    gates,
    loading,
    error,
  };
};
